import { RouteRecordRaw } from 'vue-router';

export const routes: Array<RouteRecordRaw> = [
  {
    path: 'owners-offices',
    name: 'OwnersOffices',
    component: () => import('~/views/owners-offices/OwnersOffices.vue'),
    meta: {
      title: 'Кабинеты собственников'
    }
  },

  // Settings

  {
    path: 'owners-offices/meter-auto-getting-values',
    name: 'MeterAutoGettingValues',
    component: () => import('~/views/owners-offices/lists/settings/MeterAutoGettingValues.vue'),
    meta: { title: 'Настройки автоснятия показаний ИПУ (запрета приема показаний)' }
  },
  {
    path: 'owners-offices/meter-auto-getting-values/detail/:id?',
    name: 'MeterAutoGettingValue',
    component: () => import('~/views/owners-offices/list-items/settings/MeterAutoGettingValue.vue'),
    meta: { title: 'Настройка автоснятия показаний ИПУ (запрета приема показаний)' }
  },
  {
    path: 'owners-offices/support-denied-houses',
    name: 'SupportDeniedHouses',
    component: () => import('~/views/owners-offices/lists/settings/SupportDeniedHouses.vue'),
    meta: { title: 'Дома с запретом создания заявок' }
  },
  {
    path: 'owners-offices/support-denied-houses/detail/:id?',
    name: 'SupportDeniedHouse',
    component: () => import('~/views/owners-offices/list-items/settings/SupportDeniedHouse.vue'),
    meta: { title: 'Дом с запретом создания заявок' }
  },
  // {
  //   path: 'owners-offices/meter-values-differences-limits-settings',
  //   name: 'MeterValuesDifferencesLimitsSettings',
  //   component: () => import('~/views/owners-offices/lists/settings/MeterValuesDifferencesLimitsSettings.vue'),
  //   meta: { title: 'Настройки запрета приема показаний по объему' }
  // },
  // {
  //   path: 'owners-offices/meter-values-differences-limits-settings/detail/:id?',
  //   name: 'MeterValuesDifferencesLimitsSetting',
  //   component: () => import('~/views/owners-offices/list-items/settings/MeterValuesDifferencesLimitsSetting.vue'),
  //   meta: { title: 'Настройка запрета приема показаний по объему' }
  // },
  {
    path: 'owners-offices/tasks-to-send-reports',
    name: 'OwnersOfficesTasksToSendReports',
    component: () => import('~/views/owners-offices/lists/settings/TasksToSendReports.vue'),
    meta: { title: 'Задачи по отправке отчетов' }
  },
  {
    path: 'owners-offices/tasks-to-send-reports/detail/:id?',
    name: 'OwnersOfficesTaskToSendReportsDetail',
    component: () => import('~/views/owners-offices/list-items/settings/TaskToSendReports.vue'),
    meta: { title: 'Задача по отправке отчетов' }
  },
  {
    path: 'owners-offices/company-profile',
    name: 'OwnersOfficesCompanyProfile',
    component: () => import('~/views/owners-offices/lists/settings/CompanyProfile.vue'),
    meta: { title: 'Организации' }
  },
  {
    path: 'owners-offices/company-profile/detail/:id?',
    name: 'OwnersOfficesCompanyProfileDetail',
    component: () => import('~/views/owners-offices/list-items/settings/CompanyProfileDetail.vue'),
    meta: { title: 'Организация' }
  },
  // {
  //   path: 'owners-offices/paycheck-settings-set',
  //   name: 'PaycheckSettingsSet',
  //   component: () => import('~/views/owners-offices/lists/settings/PaycheckSettingsSet.vue'),
  //   meta: { title: 'Настройки пробития чеков (список)' }
  // },
  // {
  //   path: 'owners-offices/paycheck-settings-set/detail/:id?',
  //   name: 'PaycheckSettingsSetDetail',
  //   component: () => import('~/views/owners-offices/list-items/settings/PaycheckSettingsSetDetail.vue'),
  //   meta: { title: 'Настройки пробития чеков' }
  // },
  {
    path: 'owners-offices/meter-values-sending-delay-limits',
    name: 'MeterValuesSendingDelayLimits',
    component: () => import('~/views/owners-offices/lists/settings/MeterValuesSendingDelayLimits.vue'),
    meta: { title: 'Лимиты задержки передачи показаний' }
  },
  {
    path: 'owners-offices/meter-values-sending-delay-limits/detail/:id?',
    name: 'MeterValuesSendingDelayLimit',
    component: () => import('~/views/owners-offices/list-items/settings/MeterValuesSendingDelayLimit.vue'),
    meta: { title: 'Лимит задержки передачи показаний' }
  },

  {
    path: 'owners-offices/payment-agent',
    name: 'PaymentAgents',
    component: () => import('~/views/owners-offices/lists/settings/PaymentAgents.vue'),
    meta: { title: 'Платежные агенты' }
  },
  {
    path: 'owners-offices/payment-agent/detail/:id?',
    name: 'PaymentAgentDetail',
    component: () => import('~/views/owners-offices/list-items/settings/PaymentAgentDetail.vue'),
    meta: { title: 'Платежный агент' }
  },

  {
    path: 'owners-offices/owners-lists/mobile-settings',
    name: 'MobileSettings',
    component: () => import('~/views/owners-offices/list-items/settings/MobileSettings.vue'),
    meta: { title: 'Настройки ЛК и мобильного приложения' }
  },
  {
    path: 'owners-offices/owners-lists/mobile-settings/:id/mobile-settings-change-log',
    name: 'MobileSettingsChangeLog',
    component: () => import('~/views/owners-offices/list-items/settings/MobileSettingsChangeLog.vue'),
    meta: { title: 'Логи изменений настроек ЛК и мобильного приложения' }
  },
  {
    path: 'owners-offices/owners-lists/mobile-settings/mobile-menu-settings-change-log',
    name: 'MobileMenuSettingsChangeLog',
    component: () => import('~/views/owners-offices/list-items/settings/MobileMenuSettingsChangeLog.vue'),
    meta: { title: 'Логи изменений настроек меню мобильного приложения' }
  },

  {
    path: 'owners-offices/owners-lists/data-exchange-settings/detail/:id?',
    name: 'DataExchangeSettings',
    component: () => import('~/views/owners-offices/list-items/settings/DataExchangeSettings.vue'),
    meta: { title: 'Настройка правил обмена данными' }

  },

  {
    path: 'owners-offices/owners-lists/common-settings/detail/:id?',
    name: 'CommonSettings',
    component: () => import('~/views/owners-offices/list-items/settings/CommonSettings.vue'),
    meta: { title: 'Правила формирования адреса дома' }
  },

  {
    path: 'owners-offices/owners-lists/alias-specific-settings/detail/:id?',
    name: 'AliasSpecificSettings',
    component: () => import('~/views/owners-offices/list-items/settings/AliasSpecificSettings.vue'),
    meta: { title: 'Настройки алиасов' }
  },
  {
    path: 'owners-offices/owners-lists/alias-specific-settings/:id/alias-settings-change-log',
    name: 'AliasSettingsChangeLog',
    component: () => import('~/views/owners-offices/list-items/settings/AliasSettingsChangeLog.vue'),
    meta: { title: 'Логи изменений' }
  },
  
  {
    path: 'owners-offices/owners-lists/alias-specific-settings/detail/:id?',
    name: 'AliasSpecificSettings',
    component: () => import('~/views/owners-offices/list-items/settings/AliasSpecificSettings.vue'),
    meta: { title: 'Настройки алиасов' }
  },
  // Owners lists
  {
    path: 'owners-offices/district-divisions',
    name: 'OwnersOfficesDistrictDivisions',
    component: () => import('~/views/owners-offices/lists/owners-lists/OwnersOfficesDistrictDivisions.vue'),
    meta: { title: 'Дивизионы групп районов' }
  },
  {
    path: 'owners-offices/district-divisions/detail/:id?',
    name: 'OwnersOfficesDistrictDivision',
    component: () => import('~/views/owners-offices/list-items/owners-lists/OwnersOfficesDistrictDivision.vue'),
    meta: { title: 'Дивизион групп районов' }
  },
  {
    path: 'owners-offices/groups-of-districts',
    name: 'OwnersOfficesGroupsOfDistricts',
    component: () => import('~/views/owners-offices/lists/owners-lists/OwnersOfficesGroupsOfDistricts.vue'),
    meta: { title: 'Группы районов' }
  },
  {
    path: 'owners-offices/groups-of-districts/detail/:id?',
    name: 'OwnersOfficesGroupOfDistricts',
    component: () => import('~/views/owners-offices/list-items/owners-lists/OwnersOfficesGroupOfDistricts.vue'),
    meta: { title: 'Группа районов' }
  },
  {
    path: 'owners-offices/districts',
    name: 'OwnersOfficesHomeGroups',
    component: () => import('~/views/owners-offices/lists/owners-lists/OwnersOfficesHomeGroups.vue'),
    meta: { title: 'Районы' }
  },
  {
    path: 'owners-offices/districts/detail/:id?',
    name: 'OwnersOfficesHomeGroup',
    component: () => import('~/views/owners-offices/list-items/owners-lists/OwnersOfficesHomeGroup.vue'),
    meta: { title: 'Район' }
  },

  // Houses
  {
    path: 'owners-offices/houses',
    name: 'OwnersOfficesHouses',
    component: () => import('~/views/owners-offices/lists/owners-lists/OwnersOfficesHouses.vue'),
    meta: { title: 'Дома' }
  },
  {
    path: 'owners-offices/houses/detail/:id?',
    name: 'OwnersOfficesHouse',
    component: () => import('~/views/owners-offices/list-items/owners-lists/OwnersOfficesHouse.vue'),
    meta: { title: 'Дом' }
  },
  {
    path: 'owners-offices/houses/detail/:parentId/entrances',
    name: 'OwnersOfficesEntrancesForHouse',
    component: () => import('~/views/owners-offices/lists/owners-lists/OwnersOfficesEntrancesForHouse.vue'),
    meta: { title: 'Подъезды' }
  },
  {
    path: 'owners-offices/houses/detail/:parentId/entrances/detail/:id?',
    name: 'OwnersOfficesEntranceForHouse',
    component: () => import('~/views/owners-offices/list-items/owners-lists/OwnersOfficesEntranceForHouse.vue'),
    meta: { title: 'Подъезд' }
  },
  {
    path: 'owners-offices/houses/detail/:parentId/meters',
    name: 'OwnersOfficesHouseMetersForHouse',
    component: () => import('~/views/owners-offices/lists/owners-lists/OwnersOfficesHouseMetersForHouse.vue'),
    meta: { title: 'ОДПУ' }
  },
  {
    path: 'owners-offices/houses/detail/:parentId/meters/detail/:id?',
    name: 'OwnersOfficesHouseMeterForHouse',
    component: () => import('~/views/owners-offices/list-items/owners-lists/OwnersOfficesHouseMeterForHouse.vue'),
    meta: { title: 'ОДПУ' }
  },
  {
    path: 'owners-offices/houses/detail/:parentId/cameras',
    name: 'OwnersOfficesHouseCamerasForHouse',
    component: () => import('~/views/owners-offices/lists/owners-lists/OwnersOfficesHouseCamerasForHouse.vue'),
    meta: { title: 'Камеры' }
  },
  {
    path: 'owners-offices/houses/detail/:parentId/cameras/detail/:id?',
    name: 'OwnersOfficesHouseCameraForHouse',
    component: () => import('~/views/owners-offices/list-items/owners-lists/OwnersOfficesHouseCameraForHouse.vue'),
    meta: { title: 'Камера' }
  },
  {
    path: 'owners-offices/houses/detail/:parentId/lifts',
    name: 'OwnersOfficesLiftsForHouse',
    component: () => import('~/views/owners-offices/lists/owners-lists/OwnersOfficesLiftsForHouse.vue'),
    meta: { title: 'Лифты' }
  },
  {
    path: 'owners-offices/houses/detail/:parentId/meters/detail/:id/meter-values',
    name: 'OwnersOfficesHouseMeterValuesForHouse',
    component: () => import('~/views/owners-offices/lists/owners-lists/OwnersOfficesHouseMeterValuesForHouse.vue'),
    meta: { title: 'Показания ОДПУ' }
  },
  {
    path: 'owners-offices/houses/detail/:parentId/meters/detail/:id/meter-verifications',
    name: 'OwnersOfficesHouseMeterVerificationsForHouse',
    component: () => import('~/views/owners-offices/lists/owners-lists/OwnersOfficesHouseMeterVerificationsForHouse.vue'),
    meta: { title: 'Поверки ОДПУ' }
  },

  {
    path: 'owners-offices/premises',
    name: 'OwnersOfficesPremises',
    component: () => import('~/views/owners-offices/lists/owners-lists/OwnersOfficesPremises.vue'),
    meta: { title: 'Помещения' }
  },
  
  {
    path: 'owners-offices/premises/detail/:id?',
    name: 'OwnersOfficesPremise',
    component: () => import('~/views/owners-offices/list-items/owners-lists/OwnersOfficesPremise.vue'),
    meta: { title: 'Помещение' }
  },
  {
    path: 'owners-offices/parking',
    name: 'Parkings',
    component: () => import('~/views/owners-offices/lists/owners-lists/Parkings.vue'),
    meta: { title: 'Парковки' }
  },
  {
    path: 'owners-offices/parking/detail/:id?',
    name: 'Parking',
    component: () => import('~/views/owners-offices/list-items/owners-lists/Parking.vue'),
    meta: { title: 'Парковка' }
  },
  {
    path: 'owners-offices/accounts',
    name: 'OwnersOffices.Accounts',
    component: () => import('~/views/owners-offices/lists/owners-lists/OwnersOfficesAccounts.vue'),
    meta: { title: 'Лицевые счета' }
  },
  {
    path: 'owners-offices/accounts/detail/:id?',
    name: 'OwnersOffices.Account',
    component: () => import('~/views/owners-offices/list-items/owners-lists/OwnersOfficesAccount.vue'),
    meta: { title: 'Лицевой счет' }
  },
	{
    path: 'owners-offices/accounts/fill-template-tko-accounts-processor',
    name: 'OwnersOffices.FillTemplateTKOAccountsProcessor',
    component: () => import('~/components/view/common/long-process/FillTemplateTKOAccountsProcessor.vue'),
    meta: { title: 'Выгрузить ЛС ТКО' }
  },
  {
    path: 'owners-offices/accounts/accounts-csv-file-processor',
    name: 'OwnersOffices.AccountsCsvFileProcessor',
    component: () => import('~/components/view/common/long-process/AccountsCsvFileProcessor.vue'),
    meta: { title: 'Выгрузить ЛС/ЕЛС в CSV' }
  },
  {
    path: 'owners-offices/accounts/accounts-excel-file-processor',
    name: 'OwnersOffices.AccountsExcelFileProcessor',
    component: () => import('~/components/view/common/long-process/AccountsExcelFileProcessor.vue'),
    meta: { title: 'Выгрузить ЛС/ЕЛС в Excel' }
  },
  {
    path: 'owners-offices/accounts/create-cr-accounts-processor',
    name: 'OwnersOffices.CreateCRAccountsProcessor',
    component: () => import('~/components/view/common/long-process/CreateCRAccountsProcessor.vue'),
    meta: { title: 'Создать лицевые счета для кап.ремонта' }
  },
  {
    path: 'owners-offices/accounts/account-from-tko-template-processor',
    name: 'OwnersOffices.AccountFromTkoTemplateProcessor',
    component: () => import('~/components/view/common/long-process/AccountFromTkoTemplateProcessor.vue'),
    meta: { title: 'Обновить ИЖКУ по результатам обработки шаблона ЛС ТКО' }
  },
	{
    path: 'owners-offices/accounts/detail/:parentId/mobile-accounts-for-account',
    name: 'OwnersOffices.MobileAccountsForAccount',
    component: () => import('~/views/owners-offices/lists/owners-lists/MobileAccountsForAccount.vue'),
    meta: { title: 'Мобильные аккаунты' }
  },
  {
    path: 'owners-offices/accounts/detail/:parentId/mobile-accounts-for-account/detail/:id?',
    name: 'OwnersOffices.MobileAccountForAccount',
    component: () => import('~/views/owners-offices/list-items/owners-lists/MobileAccountForAccount.vue'),
    meta: { title: 'Мобильный аккаунт' }
  },
  {
    path: 'owners-offices/accounts/detail/:parentId/bills-for-account',
    name: 'OwnersOffices.BillsForAccount',
    component: () => import('~/views/owners-offices/lists/owners-lists/BillsForAccount.vue'),
    meta: { title: 'Квитанции' }
  },
  {
    path: 'owners-offices/accounts/detail/:parentId/meters-for-account',
    name: 'OwnersOffices.MetersForAccount',
    component: () => import('~/views/owners-offices/lists/owners-lists/MetersForAccount.vue'),
    meta: { title: 'Приборы учета' }
  },
  {
    path: 'owners-offices/accounts/detail/:parentId/notification-send-logs-for-account',
    name: 'OwnersOffices.NotificationSendLogsForAccount',
    component: () => import('~/views/owners-offices/lists/owners-lists/NotificationSendLogsForAccount.vue'),
    meta: { title: 'Логи уведомлений' }
  },
  {
    path: 'owners-offices/accounts/detail/:parentId/claimants-for-account',
    name: 'OwnersOffices.ClaimantsForAccount',
    component: () => import('~/views/owners-offices/lists/owners-lists/ClaimantsForAccount.vue'),
    meta: { title: 'Взыскатели' }
  },
  {
    path: 'owners-offices/accounts/detail/:parentId/claimants-for-account/detail/:id?',
    name: 'OwnersOffices.ClaimantForAccount',
    component: () => import('~/views/owners-offices/list-items/owners-lists/ClaimantForAccount.vue'),
    meta: { title: 'Взыскатель' }
  },
  // {
  //   path: 'owners-offices/owners-lists/mobile-users',
  //   name: 'OwnersOfficesMobileAccounts',
  //   component: () => import('~/views/owners-offices/lists/owners-lists/OwnersOfficesMobileAccounts.vue'),
  //   meta: { title: 'Мобильные пользователи' }
  // },
  // {
  //   path: 'owners-offices/owners-lists/mobile-users/detail/:id?',
  //   name: 'OwnersOfficesMobileAccount',
  //   component: () => import('~/views/owners-offices/list-items/owners-lists/OwnersOfficesMobileAccount.vue'),
  //   meta: { title: 'Мобильный пользователь' }
  // },
  {
    path: 'owners-offices/mobile-users',
    name: 'OwnersOffices.MobileAccounts',
    component: () => import('~/views/owners-offices/lists/owners-lists/OwnersOfficesMobileAccounts.vue'),
    meta: { title: 'Мобильные пользователи' }
  },
  {
    path: 'owners-offices/mobile-users/detail/:id?',
    name: 'OwnersOffices.MobileAccount',
    component: () => import('~/views/owners-offices/list-items/owners-lists/OwnersOfficesMobileAccount.vue'),
    meta: { title: 'Мобильный пользователь' }
  },
  {
    path: 'owners-offices/mobile-users/detail/:parentId/devices-for-mobile-account',
    name: 'OwnersOffices.DevicesForMobileAccount',
    component: () => import('~/views/owners-offices/lists/owners-lists/DevicesForMobileAccount.vue'),
    meta: { title: 'Устройства' }
  },
  {
    path: 'owners-offices/mobile-users/detail/:parentId/accounts-for-mobile-account',
    name: 'OwnersOffices.AccountsForMobileAccount',
    component: () => import('~/views/owners-offices/lists/owners-lists/AccountsForMobileAccount.vue'),
    meta: { title: 'Лицевые счета' }
  },
  {
    path: 'owners-offices/mobile-users/detail/:parentId/accounts-for-mobile-account/detail/:id?',
    name: 'OwnersOffices.AccountForMobileAccount',
    component: () => import('~/views/owners-offices/list-items/owners-lists/AccountForMobileAccount.vue'),
    meta: { title: 'Лицевой счет' }
  },
  {
    path: 'owners-offices/mobile-users/detail/:parentId/account-link-logs-for-mobile-account',
    name: 'OwnersOffices.AccountLinkLogsForMobileAccount',
    component: () => import('~/views/owners-offices/lists/owners-lists/AccountLinkLogsForMobileAccount.vue'),
    meta: { title: 'Лог привязки лс' }
  },
  {
    path: 'owners-offices/mobile-users/detail/:parentId/objects-for-mobile-account',
    name: 'OwnersOffices.ObjectsForMobileAccount',
    component: () => import('~/views/owners-offices/lists/owners-lists/ObjectsForMobileAccount.vue'),
    meta: { title: 'Объекты СКУД' }
  },
  {
    path: 'owners-offices/auto-add-accounts',
    name: 'OwnersOfficesMobileAutoAddAccounts',
    component: () => import('~/views/owners-offices/lists/owners-lists/OwnersOfficesMobileAutoAddAccounts.vue'),
    meta: { title: 'Подключаемые лицевые счета при регистрации' }
  },
  {
    path: 'owners-offices/auto-add-accounts/detail/:id?',
    name: 'OwnersOfficesMobileAutoAddAccount',
    component: () => import('~/views/owners-offices/list-items/owners-lists/OwnersOfficesMobileAutoAddAccount.vue'),
    meta: { title: 'Подключаемый лицевой счет при регистрации' }
  },
  {
    path: 'owners-offices/devices',
    name: 'OwnersOfficesMobileAccountDevices',
    component: () => import('~/views/owners-offices/lists/owners-lists/OwnersOfficesMobileAccountDevices.vue'),
    meta: { title: 'Устройства' }
  },
  // {
  //   path: 'owners-offices/meters',
  //   name: 'Meters',
  //   component: () => import('~/views/owners-offices/lists/owners-lists/OwnersOfficesMeters.vue'),
  //   meta: { title: 'Индивидуальные приборы учета' }
  // },
  {
    path: 'owners-offices/meters/detail/:id?',
    name: 'Meter',
    component: () => import('~/views/owners-offices/list-items/owners-lists/OwnersOfficesMeter.vue'),
    meta: { title: 'Индивидуальный прибор учета' }
  },
  {
    path: 'owners-offices/meter-values',
    name: 'MeterValues',
    component: () => import('~/views/owners-offices/lists/owners-lists/MeterValues.vue'),
    meta: { title: 'Показания индивидуальных ПУ' }
  },
  {
    path: 'owners-offices/meter-verifications',
    name: 'MeterVerifications',
    component: () => import('~/views/owners-offices/lists/owners-lists/MeterVerifications.vue'),
    meta: { title: 'Поверки индивидуальных ПУ' }
  },
  // {
  //   path: 'owners-offices/house-meters',
  //   name: 'HouseMeters',
  //   component: () => import('~/views/owners-offices/lists/owners-lists/HouseMeters.vue'),
  //   meta: { title: 'Общедомовые приборы учета' }
  // },
  // {
  //   path: 'owners-offices/house-meters/detail/:id?',
  //   name: 'HouseMeter',
  //   component: () => import('~/views/owners-offices/list-items/owners-lists/HouseMeter.vue'),
  //   meta: { title: 'Общедомовой прибор учета' }
  // },
  {
    path: 'owners-offices/house-meter-values',
    name: 'HouseMeterValues',
    component: () => import('~/views/owners-offices/lists/owners-lists/HouseMeterValues.vue'),
    meta: { title: 'Показания общедомовых ПУ' }
  },
  {
    path: 'owners-offices/house-meter-verifications',
    name: 'HouseMeterVerifications',
    component: () => import('~/views/owners-offices/lists/owners-lists/HouseMeterVerifications.vue'),
    meta: { title: 'Поверки общедомовых ПУ' }
  },
  {
    path: 'owners-offices/meter-recheck-requests',
    name: 'MeterRecheckRequests',
    component: () => import('~/views/owners-offices/lists/owners-lists/MeterRecheckRequests.vue'),
    meta: { title: 'Заявки на поверку ИПУ' }
  },
  // {
  //   path: 'owners-offices/bills',
  //   name: 'OwnersOfficesBills',
  //   component: () => import('~/views/owners-offices/lists/owners-lists/BillList.vue'),
  //   meta: { title: 'Квитанции' }
  // },
  // {
  //   path: 'owners-offices/bills/detail/:id?',
  //   name: 'OwnersOfficesBill',
  //   component: () => import('~/views/owners-offices/list-items/owners-lists/OwnersOfficesBill.vue'),
  //   meta: { title: 'Квитанция' }
  // },
  // {
  //   path: 'owners-offices/debt-bills',
  //   name: 'DebtBills',
  //   component: () => import('~/views/owners-offices/lists/owners-lists/DebtBills.vue'),
  //   meta: { title: 'Квитанции по долгам' }
  // },
  // {
  //   path: 'owners-offices/debt-bills/detail/:id?',
  //   name: 'DebtBill',
  //   component: () => import('~/views/owners-offices/list-items/owners-lists/DebtBill.vue'),
  //   meta: { title: 'Квитанция по долгам' }
  // },
  {
    path: 'owners-offices/billing-centers',
    name: 'BillingCenters',
    component: () => import('~/views/owners-offices/lists/owners-lists/BillingCenters.vue'),
    meta: { title: 'Центры начислений' }
  },
  {
    path: 'owners-offices/billing-centers/detail/:id?',
    name: 'BillingCenter',
    component: () => import('~/views/owners-offices/list-items/owners-lists/BillingCenter.vue'),
    meta: { title: 'Центр начислений' }
  },
  {
    path: 'owners-offices/sent-bills',
    name: 'SentBills',
    component: () => import('~/views/owners-offices/lists/owners-lists/SentBills.vue'),
    meta: { title: 'Результаты рассылки квитанций' }
  },
  {
    path: 'owners-offices/service-suppliers',
    name: 'ServiceSuppliers',
    component: () => import('~/views/owners-offices/lists/owners-lists/ServiceSuppliers.vue'),
    meta: { title: 'Поставщики услуг' }
  },
  {
    path: 'owners-offices/service-suppliers/detail/:id?',
    name: 'ServiceSupplier',
    component: () => import('~/views/owners-offices/list-items/owners-lists/ServiceSupplier.vue'),
    meta: { title: 'Поставщик услуг' }
  },
  // {
  //   path: 'owners-offices/house-service-suppliers',
  //   name: 'HouseServiceSuppliers',
  //   component: () => import('~/views/owners-offices/lists/owners-lists/HouseServiceSuppliers.vue'),
  //   meta: { title: 'Поставщики услуг по домам' }
  // },
  // {
  //   path: 'owners-offices/house-service-suppliers/detail/:id?',
  //   name: 'HouseServiceSupplier',
  //   component: () => import('~/views/owners-offices/list-items/owners-lists/HouseServiceSupplier.vue'),
  //   meta: { title: 'Поставщик услуг по дому' }
  // },
  {
    path: 'owners-offices/blacklist-phones',
    name: 'BlackListPhones',
    component: () => import('~/views/owners-offices/lists/owners-lists/BlackListPhones.vue'),
    meta: { title: 'Черный список номеров телефона' }
  },
  {
    path: 'owners-offices/blacklist-phones/detail/:id?',
    name: 'BlackListPhone',
    component: () => import('~/views/owners-offices/list-items/owners-lists/BlackListPhone.vue'),
    meta: { title: 'Номер телефона в черном списке' }
  },

  // {START} Contacts through personal account

  // {
  //   path: 'owners-offices/contacts-through-personal-account/announcements',
  //   name: 'Announcements',
  //   component: () => import('~/views/owners-offices/lists/contactsThroughPersonalAccount/Announcements.vue'),
  //   meta: { title: 'Уведомления' }
  // },

  // {
  //   path: 'owners-offices/contacts-through-personal-account/announcements/detail/:id?',
  //   name: 'Announcement',
  //   component: () => import('~/views/owners-offices/list-items/contactsThroughPersonalAccount/AnnouncementDetails.vue'),
  //   meta: { title: 'Уведомление' }
  // },
  // {
  //   path: 'owners-offices/contacts-through-personal-account/technical-support-help-tree',
  //   name: 'TechnicalSupportHelpTree',
  //   component: () => import('~/views/owners-offices/lists/contactsThroughPersonalAccount/TechnicalSupportHelpTree.vue'),
  //   meta: { title: 'Дерево решений по тех. поддержке' }
  // },
  // {
  //   path: 'owners-offices/contacts-through-personal-account/technical-support-help-tree/detail/:id?',
  //   name: 'TechnicalSupportHelpTreeDetail',
  //   component: () => import('~/views/owners-offices/list-items/contactsThroughPersonalAccount/TechnicalSupportHelpTreeDetail.vue'),
  //   meta: { title: 'Дерево решений по тех. поддержке' }
  // },
  // {END} Contacts through personal account

  // {START} Integration with information system
  // {
  //   path: 'owners-offices/request-query-report',
  //   name: 'RequestQueryReport',
  //   component: () => import('~/views/owners-offices/lists/integrationWithInformationSystem/RequestQueryReport.vue'),
  //   meta: { title: 'Очередь заданий на загрузку' }
  // },

  {
    path: 'owners-offices/gis-exchange-tasks-report',
    name: 'GisExchangeTasksReport',
    component: () => import('~/views/owners-offices/lists/integrationWithInformationSystem/GisExchangeTasksReport.vue'),
    meta: { title: 'Сводный отчет по задачам ГИС' }
  },

  // {
  //   path: 'owners-offices/data-exchange-rules',
  //   name: 'DataExchangeRules',
  //   component: () => import('~/views/owners-offices/lists/integrationWithInformationSystem/DataExchangeRules.vue'),
  //   meta: { title: 'Правила обработки данных' }
  // },

  // {
  //   path: 'owners-offices/data-exchange-rules/detail/:id?',
  //   name: 'DataExchangeRule',
  //   component: () => import('~/views/owners-offices/list-items/integrationWithInformationSystem/DataExchangeRule.vue'),
  //   meta: { title: 'Правило обработки данных' }
  // },

  {
    path: 'owners-offices/external-base',
    name: 'ExternalBase',
    component: () => import('~/views/owners-offices/lists/integrationWithInformationSystem/ExternalBase.vue'),
    meta: { title: 'Базы данных для синхронизации' }
  },

  {
    path: 'owners-offices/external-base/detail/:id?',
    name: 'ExternalBaseDetails',
    component: () => import('~/views/owners-offices/list-items/integrationWithInformationSystem/ExternalBaseDetails.vue'),
    meta: { title: 'База данных для синхронизации' }
  },

  {
    path: 'owners-offices/account-ident-formats',
    name: 'AccountIdentFormats',
    component: () => import('~/views/owners-offices/lists/integrationWithInformationSystem/AccountIdentFormats.vue'),
    meta: { title: 'Форматы номеров лицевых счетов' }
  },

  {
    path: 'owners-offices/account-ident-formats/detail/:id?',
    name: 'AccountIdentFormat',
    component: () => import('~/views/owners-offices/list-items/integrationWithInformationSystem/AccountIdentFormat.vue'),
    meta: { title: 'Формат номера лицевого счета' }
  },

  // {END} Integration with information system

  // {START} monetization
  {
    path: 'owners-offices/additional-service-groups',
    name: 'AdditionalServiceGroups',
    component: () => import('~/views/owners-offices/lists/monetization/AdditionalServiceGroups.vue'),
    meta: { title: 'Группы доп. услуг' }
  },

  {
    path: 'owners-offices/additional-service-groups/detail/:id?',
    name: 'AdditionalServiceGroup',
    component: () => import('~/views/owners-offices/list-items/monetization/AdditionalServiceGroup.vue'),
    meta: { title: 'Группа доп. услуг' }
  },

  // {
  //   path: 'owners-offices/additional-services',
  //   name: 'AdditionalServices',
  //   component: () => import('~/views/owners-offices/lists/monetization/AdditionalServices.vue'),
  //   meta: { title: 'Доп. услуги' }
  // },

  // {
  //   path: 'owners-offices/additional-services/detail/:id?',
  //   name: 'AdditionalService',
  //   component: () => import('~/views/owners-offices/list-items/monetization/AdditionalService.vue'),
  //   meta: { title: 'Доп. услуга' }
  // },

  {
    path: 'owners-offices/shops',
    name: 'Shops',
    component: () => import('~/views/owners-offices/lists/monetization/Shops.vue'),
    meta: { title: 'Магазины' }
  },

  {
    path: 'owners-offices/shops/detail/:id?',
    name: 'Shop',
    component: () => import('~/views/owners-offices/list-items/monetization/ShopDetails.vue'),
    meta: { title: 'Магазин' }
  },

  // {
  //   path: 'owners-offices/goods',
  //   name: 'Goods',
  //   component: () => import('~/views/owners-offices/lists/monetization/Goods.vue'),
  //   meta: { title: 'Товары' }
  // },

  // {
  //   path: 'owners-offices/goods/detail/:id?',
  //   name: 'Good',
  //   component: () => import('~/views/owners-offices/list-items/monetization/GoodDetails.vue'),
  //   meta: { title: 'Товар' }
  // },

  {
    path: 'owners-offices/goods-categories',
    name: 'GoodsCategories',
    component: () => import('~/views/owners-offices/lists/monetization/GoodsCategories.vue'),
    meta: { title: 'Категории товаров' }
  },

  {
    path: 'owners-offices/goods-categories/detail/:id?',
    name: 'GoodsCategory',
    component: () => import('~/views/owners-offices/list-items/monetization/GoodsCategory.vue'),
    meta: { title: 'Категория товаров' }
  },

  {
    path: 'owners-offices/support-additional-services',
    name: 'SupportAdditionalServices',
    component: () => import('~/views/owners-offices/lists/monetization/SupportAdditionalServices.vue'),
    meta: { title: 'Прайс на доп услуги' }
  },

  {
    path: 'owners-offices/support-additional-services/detail/:id?',
    name: 'SupportAdditionalService',
    component: () => import('~/views/owners-offices/list-items/monetization/SupportAdditionalService.vue'),
    meta: { title: 'Прайс доп услуги' }
  },

  {
    path: 'owners-offices/import-price-list',
    name: 'ImportPriceList',
    component: () =>
      import('~/views/owners-offices/file-analysis/ImportPriceList.vue'),
    meta: {
      title: 'Загрузка прайс листа'
    }
  },

  {
    path: 'owners-offices/import-goods-and-shops',
    name: 'ImportGoodsAndShops',
    component: () =>
      import('~/views/owners-offices/file-analysis/ImportGoodsAndShops.vue'),
    meta: {
      title: 'Загрузка Товаров и Магазинов для Маркетплейса'
    }
  },

  {
    path: 'owners-offices/import-additional-services',
    name: 'ImportAdditionalServices',
    component: () =>
      import('~/views/owners-offices/file-analysis/ImportAdditionalServices.vue'),
    meta: {
      title: 'Загрузка доп.услуг для Маркетплейса'
    }
  },

  {
    path: 'owners-offices/import-additional-services',
    name: 'ImportAdditionalServices',
    component: () =>
      import('~/views/owners-offices/file-analysis/ImportAdditionalServices.vue'),
    meta: {
      title: 'Загрузка доп.услуг для Маркетплейса'
    }
  },

  {
    path: 'owners-offices/banners',
    name: 'Banners',
    component: () =>
      import('~/views/owners-offices/lists/monetization/Banners.vue'),
    meta: {
      title: 'Рекламные баннеры'
    }
  },

  {
    path: 'owners-offices/banners/detail/:id?',
    name: 'Banner',
    component: () =>
      import('~/views/owners-offices/list-items/monetization/BannerDetails.vue'),
    meta: {
      title: 'Рекламный баннер'
    }
  },

  // {END} monetization
  // {START} payments
  {
    path: 'owners-offices/payments/act-of-service-provision-report/',
    name: 'ActOfServiceProvisionReport',
    component: () => import('~/views/owners-offices/payments/ActOfServiceProvisionReport.vue'),
    meta: {
      title: 'Акт об оказании услуг'
    }
  },

  {
    path: 'owners-offices/payments/parking-payment-registries',
    name: 'ParkingPaymentRegistries',
    component: () => import('~/views/owners-offices/lists/payments/ParkingPaymentRegistries.vue'),
    meta: {
      title: 'Работа с реестром оплаты парковки'
    }
  },

  // {
  //   path: 'owners-offices/payments-info/paymentsinfo',
  //   name: 'OwnersOfficesPaymentsInfo',
  //   component: () => import('~/views/owners-offices/lists/payments/PaymentsInfo.vue'),
  //   meta: { title: 'Платежи' }
  // },
  {
    path: 'owners-offices/payments-info/paymentsinfo/detail/:id?',
    name: 'OwnersOfficesPaymentInfo',
    component: () => import('~/views/owners-offices/list-items/payments/PaymentInfo.vue'),
    meta: { title: 'Платеж' }
  },
  {
    path: 'owners-offices/payments-info/register-payment',
    name: 'RegisterPayment',
    component: () => import('~/views/owners-offices/lists/payments/RegisterPayment.vue'),
    meta: { title: 'Реестр оплат' }
  },
  {
    path: 'owners-offices/payments-info/insurance-payment-registries',
    name: 'InsurancePaymentRegistries',
    component: () => import('~/views/owners-offices/lists/payments/InsurancePaymentRegistries.vue'),
    meta: { title: 'Реестр оплат страховок' }
  },
  {
    path: 'owners-offices/payments-info/mobile-payments',
    name: 'MobilePayments',
    component: () => import('~/views/owners-offices/lists/payments/MobilePayments.vue'),
    meta: { title: 'Мобильные платежи' }
  },

  // {END} payments

  // {START} reports
  {
    path: 'owners-offices/reports/account-info-report/',
    name: 'AccountInfoReport',
    component: () => import('~/views/owners-offices/reports/AccountInfoReport.vue'),
    meta: {
      title: 'Информация по лицевому счету'
    }
  },
  {
    path: 'owners-offices/reports/houses-info-report/',
    name: 'HousesInfoReport',
    component: () => import('~/views/owners-offices/reports/HousesInfoReport.vue'),
    meta: {
      title: 'Информация по домам'
    }
  },
  {
    path: 'owners-offices/reports/account-extract-report/',
    name: 'AccountExtractReport',
    component: () => import('~/views/owners-offices/reports/AccountExtractReport.vue'),
    meta: {
      title: 'Выписка из лицевого счета'
    }
  },
  {
    path: 'owners-offices/reports/house-extract-report/',
    name: 'HouseExtractReport',
    component: () => import('~/views/owners-offices/reports/HouseExtractReport.vue'),
    meta: {
      title: 'Выписка по дому'
    }
  },
  {
    path: 'owners-offices/reports/company-extract-report/',
    name: 'CompanyExtractReport',
    component: () => import('~/views/owners-offices/reports/CompanyExtractReport.vue'),
    meta: {
      title: 'Выписка по организации'
    }
  },
  {
    path: 'owners-offices/reports/accounting-and-payment-report/',
    name: 'AccountingAndPaymentReport',
    component: () => import('~/views/owners-offices/reports/AccountingAndPaymentReport.vue'),
    meta: {
      title: 'Проверка начислений и платежей (Услуги)'
    }
  },
  {
    path: 'owners-offices/reports/accounting-and-payment-by-ident-report/',
    name: 'AccountingAndPaymentByIdentReport',
    component: () => import('~/views/owners-offices/reports/AccountingAndPaymentByIdentReport.vue'),
    meta: {
      title: 'Проверка начислений и платежей (ЛС)'
    }
  },
  {
    path: 'owners-offices/reports/checking-reference-integrity-report/',
    name: 'CheckingReferenceIntegrityReport',
    component: () => import('~/views/owners-offices/reports/CheckingReferenceIntegrityReport.vue'),
    meta: {
      title: 'Отчет о нарушении связанности данных'
    }
  },
  {
    path: 'owners-offices/reports/meter-exist-values-report/',
    name: 'MeterExistValuesReport',
    component: () => import('~/views/owners-offices/reports/MeterExistValuesReport.vue'),
    meta: {
      title: 'Имеющиеся показания по приборам учета'
    }
  },
  {
    path: 'owners-offices/reports/checking-bills-report/',
    name: 'CheckingBillsReport',
    component: () => import('~/views/owners-offices/reports/CheckingBillsReport.vue'),
    meta: {
      title: 'Проверка квитанций'
    }
  },
  {
    path: 'owners-offices/reports/meters-open-when-account-close-report/',
    name: 'MetersOpenWhenAccountClosedReport',
    component: () => import('~/views/owners-offices/reports/MetersOpenWhenAccountClosedReport.vue'),
    meta: {
      title: 'Открытые ПУ по закрытым ЛС'
    }
  },
  {
    path: 'owners-offices/reports/insurance-report/',
    name: 'InsuranceReport',
    component: () => import('~/views/owners-offices/reports/InsuranceReport.vue'),
    meta: {
      title: 'Отчет по страхованию'
    }
  },
  {
    path: 'owners-offices/reports/check-meters-processor/',
    name: 'CheckMetersProcessor',
    component: () => import('~/views/owners-offices/long-process/CheckMetersProcessor.vue'),
    meta: {
      title: 'Проверка заполнения ПУ'
    }
  },
  {
    path: 'owners-offices/reports/sber-debts-compare-processor/',
    name: 'SberDebtsCompareProcessor',
    component: () => import('~/views/owners-offices/long-process/SberDebtsCompareProcessor.vue'),
    meta: {
      title: 'Сравнение долгов Сбер и НИЦ',
    }
  },
  {
    path: 'owners-offices/reports/parking-eents-orders-report',
    name: 'ParkingRentsOrdersReport',
    component: () => import('~/views/owners-offices/reports/ParkingRentsOrdersReport.vue'),
    meta: {
      title: 'Отчёт по заказанным арендам машиномест',
    }
  },
  {
    path: 'owners-offices/reports/payments-registry-parking-report',
    name: 'PaymentsRegistryParkingReport',
    component: () => import('~/views/owners-offices/reports/PaymentsRegistryParkingReport.vue'),
    meta: {
      title: 'Отчет по реестру оплат парковок',
    }
  },
  // {END} reports

  // {START} analytical reports
  {
    path: 'owners-offices/analytical-reports/mobile-users-analisis-report/',
    name: 'MobileUsersAnalisisReport',
    component: () => import('~/views/owners-offices/analytical-reports/MobileUsersAnalisisReport.vue'),
    meta: {
      title: 'Анализ использования мобильного приложения'
    }
  },
  {
    path: 'owners-offices/analytical-reports/meter-values-report/',
    name: 'MeterValuesReport',
    component: () => import('~/views/owners-offices/analytical-reports/MeterValuesReport.vue'),
    meta: {
      title: 'Показания приборов учета'
    }
  },
  {
    path: 'owners-offices/analytical-reports/house-meter-values-received-report/',
    name: 'HouseMeterValuesReceivedReport',
    component: () => import('~/views/owners-offices/analytical-reports/HouseMeterValuesReceivedReport.vue'),
    meta: {
      title: 'Показания ОДПУ, переданные через МП'
    }
  },
  {
    path: 'owners-offices/analytical-reports/meters-qr-codes-report/',
    name: 'MetersQrCodesReport',
    component: () => import('~/views/owners-offices/analytical-reports/MetersQrCodesReport.vue'),
    meta: {
      title: 'Отчет по QR-кодам приборов учета'
    }
  },
  {
    path: 'owners-offices/analytical-reports/mobile-announcement-report/',
    name: 'MobileAnnouncementReport',
    component: () => import('~/views/owners-offices/analytical-reports/MobileAnnouncementReport.vue'),
    meta: {
      title: 'Статистика просмотров уведомлений'
    }
  },
  {
    path: 'owners-offices/analytical-reports/payments-registry-report/',
    name: 'PaymentsRegistryReport',
    component: () => import('~/views/owners-offices/analytical-reports/PaymentsRegistryReport.vue'),
    meta: {
      title: 'Отчет по реестру оплат'
    }
  },
  {
    path: 'owners-offices/analytical-reports/mobile-users-in-dynamics-report/',
    name: 'MobileUsersInDynamicsReport',
    component: () => import('~/views/owners-offices/analytical-reports/MobileUsersInDynamicsReport.vue'),
    meta: {
      title: 'Динамика роста пользователей мобильного приложения'
    }
  },
  {
    path: 'owners-offices/analytical-reports/mobile-detailed-statistics-report/',
    name: 'MobileDetailedStatisticsReport',
    component: () => import('~/views/owners-offices/analytical-reports/MobileDetailedStatisticsReport.vue'),
    meta: {
      title: 'Детальная статистика'
    }
  },
  {
    path: 'owners-offices/analytical-reports/mobile-summary-statistics-report/',
    name: 'MobileSummaryStatisticsReport',
    component: () => import('~/views/owners-offices/analytical-reports/MobileSummaryStatisticsReport.vue'),
    meta: {
      title: 'Сводная статистика'
    }
  },
  {
    path: 'owners-offices/analytical-reports/sessions-log/',
    name: 'SessionsLog',
    component: () => import('~/views/owners-offices/analytical-reports/SessionsLog.vue'),
    meta: {
      title: 'Журнал авторизации',
    }
  },
  {
    path: 'owners-offices/analytical-reports/callback-requests-report/',
    name: 'CallbackRequestsReport',
    component: () => import('~/views/owners-offices/analytical-reports/CallbackRequestsReport.vue'),
    meta: {
      title: 'Обращения с сайта'
    }
  },
  {
    path: 'owners-offices/analytical-reports/mobile-accounts-info-report/',
    name: 'MobileAccountsInfoReport',
    component: () => import('~/views/owners-offices/analytical-reports/MobileAccountsInfoReport.vue'),
    meta: {
      title: 'Отчет по пользователям'
    }
  },
  {
    path: 'owners-offices/analytical-reports/idents-without-mobile-account-report/',
    name: 'IdentsWithoutMobileAccountReport',
    component: () => import('~/views/owners-offices/analytical-reports/IdentsWithoutMobileAccountReport.vue'),
    meta: {
      title: 'Отчет по лицевым счетам не привязанным к моб.аккаунтам'
    }
  },
  {
    path: 'owners-offices/analytical-reports/mobile-payments-report/',
    name: 'MobilePaymentsReport',
    component: () => import('~/views/owners-offices/analytical-reports/MobilePaymentsReport.vue'),
    meta: {
      title: 'Отчет по мобильным платежам'
    }
  },
  {
    path: 'owners-offices/analytical-reports/payments-vs-paychecks-report/',
    name: 'PaymentsVsPaychecksReport',
    component: () => import('~/views/owners-offices/analytical-reports/PaymentsVsPaychecksReport.vue'),
    meta: {
      title: 'Отчет по чекам'
    }
  },
  {
    path: 'owners-offices/analytical-reports/loaded-receipts-report/',
    name: 'LoadedReceiptsReport',
    component: () => import('~/views/owners-offices/analytical-reports/LoadedReceiptsReport.vue'),
    meta: {
      title: 'Отчет по загруженным квитанциям'
    }
  },
  {
    path: 'owners-offices/analytical-reports/meter-values-robot-report/',
    name: 'MeterValuesRobotReport',
    component: () => import('~/views/owners-offices/analytical-reports/MeterValuesRobotReport.vue'),
    meta: {
      title: 'Отчет по роботу по приему ППУ'
    }
  },
  {
    path: 'owners-offices/analytical-reports/robot-for-meter-values-report/',
    name: 'RobotForMeterValuesReport',
    component: () => import('~/views/owners-offices/analytical-reports/RobotForMeterValuesReport.vue'),
    meta: {
      title: 'Отчет по роботу по приему показаний'
    }
  },
  {
    path: 'owners-offices/analytical-reports/robot-requests-report/',
    name: 'RobotRequestsReport',
    component: () => import('~/views/owners-offices/analytical-reports/RobotRequestsReport.vue'),
    meta: {
      title: 'Отчет по роботу-диспетчеру'
    }
  },
  {
    path: 'owners-offices/analytical-reports/transitions-to-external-resources/',
    name: 'TransitionsToExternalResources',
    component: () => import('~/views/owners-offices/analytical-reports/TransitionsToExternalResources.vue'),
    meta: {
      title: 'Переходы на внешние ресурсы',
    }
  },
  {
    path: 'owners-offices/analytical-reports/moe-accounts-report/',
    name: 'MoeAccountsReport',
    component: () => import('~/views/owners-offices/analytical-reports/MoeAccountsReport.vue'),
    meta: {
      title: 'Отчет по подключенным лиц. счетам МОЕ'
    }
  },
  {
    path: 'owners-offices/analytical-reports/mobile-users-activity-by-premises-report/',
    name: 'MobileUsersActivityByPremisesReport',
    component: () => import('~/views/owners-offices/analytical-reports/MobileUsersActivityByPremisesReport.vue'),
    meta: {
      title: 'Активные пользователи МП и ЛК'
    }
  },
  // {END} analytical reports

  // {START} bonus-system
  {
    path: 'owners-offices/bonus-system',
    name: 'BonusSystem',
    component: () => import('~/views/owners-offices/lists/bonusSystem/BonusSystem.vue'),
    meta: { title: 'Параметры начислений' }
  },
  {
    path: 'owners-offices/bonus-system/detail/:id?',
    name: 'BonusSystemDetails',
    component: () => import('~/views/owners-offices/list-items/bonusSystem/BonusSystemDetails.vue'),
    meta: { title: 'Вариант параметров начислений' }
  },
  {
    path: 'owners-offices/bonus-programs',
    name: 'BonusPrograms',
    component: () => import('~/views/owners-offices/lists/bonusSystem/BonusPrograms.vue'),
    meta: { title: 'Бонусные программы' }
  },
  {
    path: 'owners-offices/bonus-programs/detail/:id?',
    name: 'BonusProgram',
    component: () => import('~/views/owners-offices/list-items/bonusSystem/BonusProgram.vue'),
    meta: { title: 'Бонусная программа' }
  },
  {
    path: 'owners-offices/bonus-cash-flow-report/',
    name: 'BonusCashFlowReport',
    component: () => import('~/views/owners-offices/bonus-system/BonusCashFlowReport.vue'),
    meta: {
      title: 'Отчет по бонусам'
    }
  },
  // {END} bonus-system

  // {START} surveys
  {
    path: 'owners-offices/questions-groups',
    name: 'QuestionGroups',
    component: () => import('~/views/owners-offices/lists/surveys/QuestionGroups.vue'),
    meta: { title: 'Опросы и вопросы' }
  },
  {
    path: 'owners-offices/questions-groups/detail/:id?',
    name: 'QuestionGroup',
    component: () => import('~/views/owners-offices/list-items/surveys/QuestionGroup.vue'),
    meta: { title: 'Группа опросов и вопросов' }
  },
  {
    path: 'owners-offices/surveys/questions-report/',
    name: 'QuestionsReport',
    component: () => import('~/views/owners-offices/surveys/QuestionsReport.vue'),
    meta: {
      title: 'Отчет по опросам'
    }
  },
  {
    path: 'owners-offices/surveys/question-results-report/',
    name: 'QuestionResultsReport',
    component: () => import('~/views/owners-offices/surveys/QuestionResultsReport.vue'),
    meta: {
      title: 'Результаты опросов'
    }
  },
  // {END} surveys
  // {START} loading from excel
  {
    path: 'owners-offices/loading-from-excel/import-supply-contract-info/',
    name: 'OwnersOfficesImportSupplyContractInfo',
    component: () => import('~/views/owners-offices/file-analysis/ImportSupplyContractInfo.vue'),
    meta: {
      title: 'Загрузка дат ДРСО'
    }
  },
  {
    path: 'owners-offices/loading-from-excel/import-fias',
    name: 'OwnersOfficesImportFias',
    component: () =>
      import('~/views/owners-offices/file-analysis/ImportFias.vue'),
    meta: {
      title: 'Загрузка ФИАС домов'
    }
  },

  {
    path: 'owners-offices/loading-from-excel/import-fias-address',
    name: 'OwnersOfficesImportFiasAddress',
    component: () =>
      import(
        '~/views/owners-offices/file-analysis/ImportFiasAddress.vue'
        ),
    meta: {
      title: 'Загрузка адресов домов по ФИАС коду'
    }
  },

  {
    path: 'owners-offices/loading-from-excel/import-executing-jobs',
    name: 'OwnersOfficesImportExecutingJobs',
    component: () =>
      import(
        '~/views/owners-offices/file-analysis/ImportExecutingJobs.vue'
        ),
    meta: {
      title: 'Загрузка выполняемых работ'
    }
  },

  {
    path: 'owners-offices/loading-from-excel/import-meters',
    name: 'OwnersOfficesImportMeters',
    component: () =>
      import('~/views/owners-offices/file-analysis/ImportMeters.vue'),
    meta: {
      title: 'Загрузка приборов учета'
    }
  },

  {
    path: 'owners-offices/loading-from-excel/import-meter-values',
    name: 'OwnersOfficesImportMeterValues',
    component: () =>
      import(
        '~/views/owners-offices/file-analysis/ImportMeterValues.vue'
        ),
    meta: {
      title: 'Загрузка показаний приборов учета'
    }
  },
  {
    path: 'owners-offices/loading-from-excel/import-premises',
    name: 'OwnersOfficesImportPremises',
    component: () =>
      import('~/views/owners-offices/file-analysis/ImportPremises.vue'),
    meta: {
      title: 'Загрузка помещений'
    }
  },

  {
    path: 'owners-offices/loading-from-excel/bills-check',
    name: 'OwnersOfficesBillsCheck',
    component: () =>
      import('~/views/owners-offices/file-analysis/BillsCheck.vue'),
    meta: {
      title: 'Проверка загрузки квитанций'
    }
  },

  {
    path: 'owners-offices/loading-from-excel/import-debt-cases',
    name: 'OwnersOfficesImportDebtCases',
    component: () =>
      import('~/views/owners-offices/file-analysis/ImportDebtCases.vue'),
    meta: {
      title: 'Загрузка дел должников (расширенная)'
    }
  },

  {
    path: 'owners-offices/loading-from-excel/import-supply-contract-guids',
    name: 'OwnersOfficesImportSupplyContractGuids',
    component: () =>
      import(
        '~/views/owners-offices/file-analysis/ImportSupplyContractGuids.vue'
        ),
    meta: {
      title: 'Загрузка GUID ДРСО'
    }
  },

  {
    path: 'owners-offices/loading-from-excel/import-work-lists',
    name: 'OwnersOfficesImportWorkLists',
    component: () =>
      import('~/views/owners-offices/file-analysis/ImportWorkLists.vue'),
    meta: {
      title: 'Загрузка перечней и планов работ'
    }
  },

  {
    path: 'owners-offices/loading-from-excel/import-houses',
    name: 'OwnersOfficesImportHouses',
    component: () =>
      import('~/views/owners-offices/file-analysis/ImportHouses.vue'),
    meta: {
      title: 'Загрузка домов'
    }
  },

  {
    path: 'owners-offices/loading-from-excel/import-account-dept-services',
    name: 'OwnersOfficesImportAccountDebtServices',
    component: () => import('~/views/owners-offices/file-analysis/ImportAccountDebtServices.vue'),
    meta: {
      title: 'Загрузка квитанций'
    }
  },

  {
    path: 'owners-offices/loading-from-excel/import-bills-extended',
    name: 'OwnersOfficesImportBillsExtended',
    component: () =>
      import(
        '~/views/owners-offices/file-analysis/ImportBillsExtended.vue'
        ),
    meta: {
      title: 'Загрузка квитанций расширенная'
    }
  },

  {
    path: 'owners-offices/loading-from-excel/import-payments',
    name: 'OwnersOfficesImportPayments',
    component: () =>
      import('~/views/owners-offices/file-analysis/ImportPayments.vue'),
    meta: {
      title: 'Загрузка оплат'
    }
  },

  {
    path: 'owners-offices/loading-from-excel/import-mobile-auto-add-accounts',
    name: 'ImportMobileAutoAddAccounts',
    component: () =>
      import('~/views/owners-offices/file-analysis/ImportMobileAutoAddAccounts.vue'),
    meta: {
      title: 'Загрузка автоматически подключаемых лицевых счетов'
    }
  },

  {
    path: 'owners-offices/loading-from-excel/import-account-contacts',
    name: 'ImportAccountContacts',
    component: () =>
      import('~/views/owners-offices/file-analysis/ImportAccountContacts.vue'),
    meta: {
      title: 'Загрузка контактов по ЛС',
    }
  },
  // {END} loading from excel

  // {START} internet providers
  {
    path: 'owners-offices/internet-providers',
    name: 'InternetProviders',
    component: () => import('~/views/owners-offices/lists/internetProviders/InternetProviders.vue'),
    meta: { title: 'Интернет-провайдеры' }
  },

  {
    path: 'owners-offices/internet-providers/detail/:id?',
    name: 'InternetProvider',
    component: () => import('~/views/owners-offices/list-items/internetProviders/InternetProvider.vue'),
    meta: { title: 'Интернет-провайдер' }
  },

  {
    path: 'owners-offices/internet-providers-tariffs',
    name: 'InternetProvidersTariffs',
    component: () => import('~/views/owners-offices/lists/internetProviders/InternetProvidersTariffs.vue'),
    meta: { title: 'Тарифы интернет-провайдеров' }
  },

  {
    path: 'owners-offices/internet-providers-tariffs/detail/:id?',
    name: 'InternetProviderTariff',
    component: () => import('~/views/owners-offices/list-items/internetProviders/InternetProviderTariff.vue'),
    meta: { title: 'Тариф интернет-провайдера' }
  },

  {
    path: 'owners-offices/internet-providers-tariffs-connected',
    name: 'InternetProvidersTariffsConnected',
    component: () => import('~/views/owners-offices/lists/internetProviders/InternetProvidersTariffsConnected.vue'),
    meta: { title: 'Подключенные тарифы интернет-провайдеров' }
  },

  {
    path: 'owners-offices/internet-providers-tariffs-connected/detail/:id?',
    name: 'InternetProviderTariffConnected',
    component: () => import('~/views/owners-offices/list-items/internetProviders/InternetProviderTariffConnected.vue'),
    meta: { title: 'Подключенный тариф интернет-провайдера' }
  },
  // {END} internet providers
  // {END} loading from excel  
  // {START} long-process
  {
    path: 'owners-offices/meter-recheck-caller-processor',
    name: 'MeterRecheckCallerProcessor',
    component: () => import('~/views/owners-offices/long-process/MeterRecheckCallerProcessor.vue'),
    meta: {
      title: 'Запуск звонков через UIS с уведомлением о поверке прибора учета'
    }
  },
  {
    path: 'owners-offices/check-meter-processor',
    name: 'CheckMetersProcessor',
    component: () => import('~/views/owners-offices/long-process/CheckMetersProcessor.vue'),
    meta: {
      title: 'Проверка заполнения ПУ'
    }
  },
  {
    path: 'owners-offices/import-capital-fund-size-processor',
    name: 'OwnersOffices.ImportCapitalFundSizeProcessor',
    component: () => import('~/views/owners-offices/long-process/ImportCapitalFundSizeProcessor.vue'),
    meta: {
      title: 'Загрузка данных о размере фондов капитального ремонта'
    }
  },
  {
    path: 'owners-offices/archive-meters-by-excel-processor',
    name: 'ArchiveMetersByExcelProcessor',
    component: () => import('~/views/owners-offices/long-process/ArchiveMetersByExcelProcessor.vue'),
    meta: {
      title: 'Архивация приборов учета ИПУ списком из Excel'
    }
  },
  {
    path: 'owners-offices/archive-meters-processor',
    name: 'ArchiveMetersProcessor',
    component: () => import('~/views/owners-offices/long-process/ArchiveMetersProcessor.vue'),
    meta: {
      title: 'Архивация приборов учета ИПУ'
    }
  },
  {
    path: 'owners-offices/close-accounts-by-excel-processor',
    name: 'CloseAccountsByExcelProcessor',
    component: () => import('~/views/owners-offices/long-process/CloseAccountsByExcelProcessor.vue'),
    meta: {
      title: 'Массовое закрытие ЛС списком из Excel'
    }
  },
  {
    path: 'owners-offices/close-accounts-processor',
    name: 'CloseAccountsProcessor',
    component: () => import('~/views/owners-offices/long-process/CloseAccountsProcessor.vue'),
    meta: {
      title: 'Массовое закрытие ЛС'
    }
  },
  {
    path: 'gis/supply-contract-subjects-resource-pair-create-by-meter-resource-processor',
    name: 'SupplyContractSubjectsResourcePairCreateByMeterResourceProcessor',
    component: () => import('~/views/owners-offices/long-process/SupplyContractSubjectsResourcePairCreateByMeterResourceProcessor.vue'),
    meta: {
      title: 'Добавление услуги и ресурса в предмет ДРСО на основе ресурса ИПУ'
    }
  },

  // {
  //   path: 'owners-offices/robot-settings',
  //   name: 'RobotSettings',
  //   component: () => import('~/views/owners-offices/list-items/RobotSettings.vue'),
  //   meta: {
  //     title: 'Настройки Робота'
  //   }
  // },

  {
    path: 'owners-offices/bills-delete-by-period-processor',
    name: 'BillsDeleteByPeriodProcessor',
    component: () => import('~/views/owners-offices/long-process/BillsDeleteByPeriodProcessor.vue'),
    meta: {
      title: 'Удалить квитанции за период'
    }
  },
  {
    path: 'owners-offices/delete-meter-values-by-period-processor',
    name: 'DeleteMeterValuesByPeriodProcessor',
    component: () => import('~/views/owners-offices/long-process/DeleteMeterValuesByPeriodProcessor.vue'),
    meta: {
      title: 'Удаление показаний за период'
    }
  },
  {
    path: 'owners-offices/export-houses-to-excel-processor',
    name: 'OwnersOffices.ExportHousesToExcelProcessor',
    component: () => import('~/views/electronic-control-room/long-process/ExportHousesToExcelProcessor.vue'),
    meta: {
      title: 'Выгрузить доп. информацию по домам (XLSX)'
    }
  },
  {
    path: 'owners-offices/export-houses-without-fias-processor',
    name: 'OwnersOffices.ExportHousesWithoutFiasProcessor',
    component: () => import('~/views/electronic-control-room/long-process/ExportHousesWithoutFiasProcessor.vue'),
    meta: {
      title: 'Выгрузить дома без ФИАС в CSV файл'
    }
  },
  {
    path: 'owners-offices/ExportPremiseGisNumberProcessor',
    name: 'OwnersOffices.ExportPremiseGisNumberProcessor',
    component: () => import('~/views/interactiveAccess/long-process/ExportPremiseGisNumberProcessor.vue'),
    meta: {
      title: 'Экспорт номеров помещений ГИС в Excel'
    }
  },
  {
    path: 'owners-offices/fill-empty-types-services-for-bills-processor',
    name: 'FillEmptyTypesServicesForBillsProcessor',
    component: () => import('~/views/owners-offices/long-process/FillEmptyTypesServicesForBillsProcessor.vue'),
    meta: {
      title: 'Заполнить пустые типы услуг в квитанциях'
    }
  },
  {
    path: 'owners-offices/house-creation-master-processor',
    name: 'OwnersOffices.HouseCreationMasterProcessor',
    component: () => import('~/views/electronic-control-room/long-process/HouseCreationMasterProcessor.vue'),
    meta: {
      title: 'Мастер создания дома'
    }
  },
  {
    path: 'owners-offices/house-fiases-processor',
    name: 'OwnersOffices.HouseFiasesProcessor',
    component: () => import('~/views/electronic-control-room/long-process/HouseFiasesProcessor.vue'),
    meta: {
      title: 'Загрузить ФИАСы'
    }
  },
  {
    path: 'owners-offices/houses-for-tko-contract-processor',
    name: 'OwnersOffices.HousesForTkoContractProcessor',
    component: () => import('~/views/electronic-control-room/long-process/HousesForTkoContractProcessor.vue'),
    meta: {
      title: 'Заполнить шаблон по добавлению ОЖФ в договор ТКО(XLSX)'
    }
  },
  {
    path: 'owners-offices/house-type-by-premise-type-processor',
    name: 'OwnersOffices.HouseTypeByPremiseTypeProcessor',
    component: () => import('~/views/electronic-control-room/long-process/HouseTypeByPremiseTypeProcessor.vue'),
    meta: {
      title: 'Изменение типа домов по кол-ву помещений'
    }
  },
  {
    path: 'owners-offices/import-houses-from-excel-processor',
    name: 'OwnersOffices.ImportHousesFromExcelProcessor',
    component: () => import('~/views/electronic-control-room/long-process/ImportHousesFromExcelProcessor.vue'),
    meta: {
      title: 'Загрузить доп. информацию по домам (XLSX)'
    }
  },
  {
    path: 'owners-offices/merge-service-on-bills-processor',
    name: 'MergeServiceOnBillsProcessor',
    component: () => import('~/views/owners-offices/long-process/MergeServiceOnBillsProcessor.vue'),
    meta: {
      title: 'Слияние услуги/ресурса'
    }
  },
  {
    path: 'owners-offices/premises-not-linked-to-account-remove-processor',
    name: 'OwnersOffices.PremisesNotLinkedToAccountRemoveProcessor',
    component: () => import('~/views/electronic-control-room/long-process/PremisesNotLinkedToAccountRemoveProcessor.vue'),
    meta: {
      title: 'Удалить помещения, не привязанные к ЛС'
    }
  },
  {
    path: 'owners-offices/refill-service-types-in-bills-processor',
    name: 'RefillServiceTypesInBillsProcessor',
    component: () => import('~/views/owners-offices/long-process/RefillServiceTypesInBillsProcessor.vue'),
    meta: {
      title: 'Перезаполнение типов услуг в квитанциях'
    }
  },
  {
    path: 'owners-offices/update-houses-addresses-processor',
    name: 'OwnersOffices.UpdateHousesAddressesProcessor',
    component: () => import('~/views/electronic-control-room/long-process/UpdateHousesAddressesProcessor.vue'),
    meta: {
      title: 'Обновление адресов домов'
    }
  },
  {
    path: 'owners-offices/export-tko-payments-info-processor',
    name: 'ExportTkoPaymentsInfoProcessor',
    component: () => import('~/views/owners-offices/long-process/ExportTkoPaymentsInfoProcessor.vue'),
    meta: {
      title: 'Выгрузка оплат ТКО'
    }
  },
  {
    path: 'owners-offices/create-bills-pdf-processor',
    name: 'CreateBillsPdfProcessor',
    component: () => import('~/views/owners-offices/long-process/CreateBillsPdfProcessor.vue'),
    meta: {
      title: 'Генерация pdf-квитанций'
    }
  },
  // {END} long-process
];

